/**
 * Stylized small map graphic of the three prairie provinces (AB, SK, MB)
 * with city pins for North West Asphalt's service area.
 *
 * Coordinates are tuned to a 600x400 viewBox.
 */
export const PrairieMap = ({ className = "" }) => {
  const cities = [
    { name: "Medicine Hat", x: 165, y: 295, code: "MH" },
    { name: "Lloydminster", x: 195, y: 165, code: "LL" },
    { name: "Regina", x: 320, y: 285, code: "RG" },
    { name: "Brandon", x: 470, y: 295, code: "BR" },
  ];

  return (
    <svg
      viewBox="0 0 600 400"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Service area map: Alberta, Saskatchewan, Manitoba"
    >
      <defs>
        <pattern
          id="grid"
          width="20"
          height="20"
          patternUnits="userSpaceOnUse"
        >
          <path
            d="M 20 0 L 0 0 0 20"
            fill="none"
            stroke="#27272a"
            strokeWidth="0.6"
          />
        </pattern>
        <radialGradient id="pulse" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#f59e0b" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#f59e0b" stopOpacity="0" />
        </radialGradient>
      </defs>

      {/* Background grid */}
      <rect width="600" height="400" fill="url(#grid)" />

      {/* Province silhouettes — stylized prairie outline (AB | SK | MB) */}
      {/* Alberta */}
      <path
        d="M 60 80 L 230 80 L 230 360 L 60 360 Z"
        fill="#18181b"
        stroke="#3f3f46"
        strokeWidth="1.5"
      />
      {/* Saskatchewan */}
      <path
        d="M 230 80 L 400 80 L 400 360 L 230 360 Z"
        fill="#18181b"
        stroke="#3f3f46"
        strokeWidth="1.5"
      />
      {/* Manitoba — narrower top with western jog */}
      <path
        d="M 400 80 L 545 80 L 555 200 L 540 360 L 400 360 Z"
        fill="#18181b"
        stroke="#3f3f46"
        strokeWidth="1.5"
      />

      {/* Province labels */}
      <text
        x="145"
        y="105"
        textAnchor="middle"
        fill="#52525b"
        fontFamily="Big Shoulders Display, sans-serif"
        fontWeight="900"
        fontSize="22"
        letterSpacing="2"
      >
        AB
      </text>
      <text
        x="315"
        y="105"
        textAnchor="middle"
        fill="#52525b"
        fontFamily="Big Shoulders Display, sans-serif"
        fontWeight="900"
        fontSize="22"
        letterSpacing="2"
      >
        SK
      </text>
      <text
        x="475"
        y="105"
        textAnchor="middle"
        fill="#52525b"
        fontFamily="Big Shoulders Display, sans-serif"
        fontWeight="900"
        fontSize="22"
        letterSpacing="2"
      >
        MB
      </text>

      {/* Province dividers (subtle accent) */}
      <line x1="230" y1="120" x2="230" y2="350" stroke="#27272a" strokeDasharray="3 4" />
      <line x1="400" y1="120" x2="400" y2="350" stroke="#27272a" strokeDasharray="3 4" />

      {/* City pins */}
      {cities.map((c, i) => (
        <g key={i}>
          {/* Pulse halo */}
          <circle cx={c.x} cy={c.y} r="22" fill="url(#pulse)">
            <animate
              attributeName="r"
              values="14;26;14"
              dur="3s"
              repeatCount="indefinite"
              begin={`${i * 0.6}s`}
            />
            <animate
              attributeName="opacity"
              values="0.8;0;0.8"
              dur="3s"
              repeatCount="indefinite"
              begin={`${i * 0.6}s`}
            />
          </circle>
          {/* Outer ring */}
          <circle
            cx={c.x}
            cy={c.y}
            r="9"
            fill="#09090b"
            stroke="#f59e0b"
            strokeWidth="2"
          />
          {/* Inner dot */}
          <circle cx={c.x} cy={c.y} r="3.5" fill="#f59e0b" />
          {/* Name label */}
          <text
            x={c.x}
            y={c.y - 18}
            textAnchor="middle"
            fill="#fafaf9"
            fontFamily="Manrope, sans-serif"
            fontSize="11"
            fontWeight="700"
            letterSpacing="0.5"
          >
            {c.name}
          </text>
        </g>
      ))}

      {/* Legend */}
      <g transform="translate(60, 380)">
        <circle cx="6" cy="0" r="4" fill="#f59e0b" stroke="#09090b" strokeWidth="1" />
        <text
          x="18"
          y="4"
          fill="#a1a1aa"
          fontFamily="Manrope, sans-serif"
          fontSize="10"
          fontWeight="600"
          letterSpacing="2"
        >
          NORTH WEST ASPHALT · SERVICE AREA
        </text>
      </g>
    </svg>
  );
};
